import timezones from 'src/utils/timezones.json'

const formatPriceWithCurrency = (price, currencyPrefix, currencySuffix) => {
  if (currencyPrefix) {
    return `${currencyPrefix}${price}`;
  } else {
    return `${price}${currencySuffix}`;
  }
};

function getObjectByKeys(keys, object) {
  const result = {}

  for (const key of keys) {
    if (key === 'payme_json' && !!object.get('payme_json')) {
      result[key] = JSON.parse(object.get(key))
      continue
    }
    result[key] = object.get ? object.get(key) : object[key]
  }
  return result
}

function getTimezoneByText( text) {
  for (let i = 0; i < timezones.length; i++) {
      if (timezones[i].text === text) {
          return timezones[i];
      }
  }
  return null;
}

function getTimeOfTimezone(timezoneText) {
  const timezone = getTimezoneByText(timezoneText);
  if (timezone) {
      const now = new Date().toLocaleString("en-US", {timeZone: timezone.utc[0]});
      const [timeString, ampm] = now.split(", ")[1].split(" ");
      const [hours, minutes] = timeString.split(":").map(Number);
      const adjustedHours = (hours % 12) + (ampm === "PM" ? 12 : 0);
      return { hours: adjustedHours, minutes };
  } else {
      console.error('Timezone not found');
      return null;
  }
}

const getCountry = () => {
  return fetch("https://ip2c.org/s")
    .then(response => response.text())
    .then(response => {
      const result = (response || "").toString();

      if (!result || result[0] !== "1") {
        throw new Error("unable to fetch the country");
      }

      return result.substr(2, 2);
    });
};


function truncateString (str) {
  if (str.length > 7) {
  return str.substring(0, 7) + '.'
  }
  return str
}


/**
 * Get time (HH:mm) for a given timezone string like "(UTC+02:00) Jerusalem".
 *
 * @param {string} timezoneString
 * @param {Date | number | string} [dateInput=new Date()]
 * @returns {{ hours: string, minutes: string }}
 */
function getTimeFromTimezoneString(timezoneString, dateInput = new Date()) {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) {
    throw new Error('Invalid dateInput');
  }

  // Accept "(UTC+02:00) Jerusalem" AND the offset-less UTC+0 labels used by the
  // timezone list for GMT zones, e.g. "(UTC) Coordinated Universal Time",
  // "(UTC) Edinburgh, London" — treat those as UTC+00:00 instead of throwing.
  const match = typeof timezoneString === 'string'
    ? timezoneString.match(/UTC([+-])(\d{2}):(\d{2})/)
    : null;

  let totalOffsetMinutes;
  if (match) {
    const sign = match[1] === '+' ? 1 : -1;
    const hoursOffset = parseInt(match[2], 10);
    const minutesOffset = parseInt(match[3], 10);
    totalOffsetMinutes = sign * (hoursOffset * 60 + minutesOffset);
  } else if (typeof timezoneString === 'string' && /UTC/.test(timezoneString)) {
    totalOffsetMinutes = 0; // "(UTC) …" → +00:00
  } else {
    throw new Error('Invalid timezone format');
  }

  // Convert given moment to UTC, independent of server locale
  const utcMs = date.getTime() + date.getTimezoneOffset() * 60_000;

  // Apply target offset
  const target = new Date(utcMs + totalOffsetMinutes * 60_000);

  return {
    hours: String(target.getHours()).padStart(2, '0'),
    minutes: String(target.getMinutes()).padStart(2, '0')
  };
}


const getVal = (obj, key) => (obj && obj.get ? obj.get(key) : obj[key]);
const toMinutes = (d) => {
  if (!d) return 0;

  if (typeof d === 'string') {
    const m = d.match(/^(\d{1,2}):(\d{2})$/);
    if (m) {
      const hh = parseInt(m[1], 10);
      const mm = parseInt(m[2], 10);
      if (hh >= 0 && hh < 24 && mm >= 0 && mm < 60) return hh * 60 + mm;
    }
  }

  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return 0;
  return date.getUTCHours() * 60 + date.getUTCMinutes();
};


function hasOnePlusOne(business, item, now = new Date()) {
  if (!business) return false;

  const timezone = business.get('time_zone')

  if(!timezone) return false
  const time = getTimeFromTimezoneString(timezone, now)

  return isOnePlusOneInTime(business, item, time)
}

function isOnePlusOneInTime(business, item, time) {
  if(!time || !time.hours || !business) return false
  // console.log('hasOnePlusOne 1', time)
  const nowMin = parseInt(time.hours) * 60 + parseInt(time.minutes);
  // const nowMin = now instanceof Date ? now.getHours() * 60 + now.getMinutes() : toMinutes(now);

  // console.log('hasOnePlusOne 2', nowMin)
  if (nowMin == null) return false;

  // console.log('hasOnePlusOne 3', getVal(business, "allow_1plus1"))
  if (getVal(business, "allow_1plus1") !== true) return false;

  const s1Start = toMinutes(getVal(business, "one_plus_one_from1"));
  const s1End = toMinutes(getVal(business, "one_plus_one_to1"));
  // console.log('start end',s1Start, s1End)
  const s1InTime = s1Start != null && s1End != null && nowMin >= s1Start && nowMin <= s1End;

  const s2Start = toMinutes(getVal(business, "one_plus_one_from2"));
  const val = getVal(business, "one_plus_one_to2")
  // console.log('end', val)
  const s2End = toMinutes(val);
  const s2InTime = s2Start != null && s2End != null && nowMin >= s2Start && nowMin <= s2End;
  // const getItemVal = (key) => (item?.get ? item.get(key) : item?.[key]);
  const itemSlot1 = getVal(item,"is_Slot1") === true;
  const itemSlot2 = getVal(item,"is_Slot2") === true;
  // console.log('hasOnePlusOne 4',s1InTime, itemSlot1,s2InTime , itemSlot2)
  // hasOnePlusOne 4 false false true false

  return (s1InTime && itemSlot1) || (s2InTime && itemSlot2);
}

export { 
  getTimeOfTimezone,
  getTimezoneByText,
  formatPriceWithCurrency,
  getObjectByKeys,
  getCountry,
  truncateString,
  hasOnePlusOne,
  isOnePlusOneInTime
};
